module.exports = [{
      plugin: require('D:/tmp/MarsWeather/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
